// Firebase Configuration
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getAnalytics } from 'firebase/analytics'
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from 'firebase/app-check'

const firebaseConfig = {
  apiKey: "AIzaSyAvd_7zouzclYoXQGhBHwrpwzfnHdWEnbY",
  authDomain: "filesig-crm.firebaseapp.com",
  projectId: "filesig-crm",
  storageBucket: "filesig-crm.firebasestorage.app",
  messagingSenderId: "986286716054",
  appId: "1:986286716054:web:ea9abca28c67f2cd5efeb7",
  measurementId: "G-Y8F3QCT7MR"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const auth = getAuth(app)
export const db = getFirestore(app)
// Functions region - adjust if your functions are in a different region
export const functions = getFunctions(app)

// Initialize Analytics (only in browser environment)
if (typeof window !== 'undefined') {
  getAnalytics(app)
  
  // Initialize App Check for Firestore protection
  // App Check helps protect your Firestore database from abuse by ensuring requests come from your authentic app
  // 
  // Next steps in Firebase Console:
  // 1. Go to Firebase Console → App Check → Apps
  // 2. Enable App Check enforcement for Firestore
  // 3. Optionally enable enforcement for Cloud Functions if you want to verify tokens there too
  //
  // Note: If you prefer reCAPTCHA Enterprise, use: new ReCaptchaEnterpriseProvider('your-site-key')
  try {
    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('6Le2ekAsAAAAAP0LTLzJUektzr3iI95WqukNLeZk'),
      isTokenAutoRefreshEnabled: true // Automatically refresh App Check tokens
    })
    console.log('App Check initialized successfully')
  } catch (error) {
    console.warn('App Check initialization failed:', error)
    console.warn('App will continue without App Check. Cloud Functions may require App Check to be enabled.')
  }
}

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account'
})

export default app

